// Material UI icons
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFileRounded';

export default function getFileIcon(fileType: string) {
   return <InsertDriveFileIcon fontSize="small"/>;
}